/** @format */

import {styled} from '@mui/material/styles';

export type SizeType = 'small' | 'large';

const getWidth = (size?: SizeType) => {
  return size === 'small' ? '600px' : '880px';
};

const getHeight = (size?: SizeType) => {
  return size === 'small' ? '360px' : '500px';
};

export interface RootProps {
  size?: SizeType;
  overrideWidth?: string;
  overrideHeight?: string;
}

export const Root = styled('iframe', {
  shouldForwardProp: prop =>
    prop !== 'size' && prop !== 'overrideWidth' && prop !== 'overrideHeight',
})<RootProps>(({size, overrideWidth, overrideHeight}) => ({
  width: overrideWidth || getWidth(size),
  height: overrideHeight || getHeight(size),
  border: 'none',
}));
